import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'
import { commonStyle, getAuthBackgroundColor } from './getSelectorStyle'
import { DISABLED_OPACITY } from './constants'

export const Checkbox: ComponentStyleConfig = {
  variants: {
    default: (props: Dict) => ({
      control: {
        ...commonStyle(props),
      },
      icon: {
        color: mode('rw1.colors.light.white', 'rw1.colors.dark.white')(props),
      },
    }),
    auth: (props: Dict) => ({
      control: {
        borderRadius: 'base',
        border: 'inherit',
        ...getAuthBackgroundColor(props),
        _checked: {
          ...getAuthBackgroundColor(props),
          _disabled: {
            opacity: DISABLED_OPACITY,
            // ...getAuthBackgroundColor(props),
          },
          _hover: {
            ...getAuthBackgroundColor(props),
          },
        },
        _hover: {
          ...getAuthBackgroundColor(props),
        },
        _disabled: {
          opacity: DISABLED_OPACITY,
          // ...getAuthBackgroundColor(props),
        },
      },
      icon: {
        color: mode('rw1.text.light.6', 'rw1.text.dark.6')(props),
      },
    }),
  },
  defaultProps: {
    variant: 'default',
  },
}
